export default {
    searchForACompetency: 'Search for a competency',
    searchEmptyResult: "No competencies matching '{{query}}'",
    emptyState: {
        message:
            'No competency groups yet. Create your first group to start organizing your competencies.',
        addGroup: 'Add a group',
    },
    exploreCompetencies: 'Explore competencies',
    browseLibrary: {
        title: 'Competency Library',
        subtitle: 'Explore and import pre-defined competencies on your account',
        searchPlaceholder: 'Search competencies...',
        noResults: "No competencies found for '{{query}}'",
        import: 'Import',
        alreadyImported: 'Already imported',
        footerCount: '{{count}} competencies imported',
        importSuccess: "Group '{{name}}' imported with {{count}} competencies",
        close: 'Close',
    },
    actionItems: {
        editGroup: 'Modify group',
        assignGroup: 'Assign group',
        assignGroupEmptyTooltip: 'Add at least one active competency to assign this group.',
        deactivateGroup: 'Deactivate group',
        activateGroup: 'Activate group',
        deleteGroup: 'Delete group',
    },
    modifyGroupSuccessMessage: 'Group modified successfully',
    updateGroupStatusSuccessMessage: 'Group status updated successfully',
    deleteGroupSuccessMessage: 'Group deleted successfully',
    deactivation: {
        dialogTitle: 'Deactivate group',
        warning:
            'Warning {{activeCount}} active competencies will be deactivated. {{individuallyDeactivatedCount}} competency(ies) already individually deactivated will remain unchanged.',
        warningNoIndividual: 'Warning {{activeCount}} active competencies will be deactivated.',
        warningNoActive:
            '{{individuallyDeactivatedCount}} competency(ies) already individually deactivated will remain unchanged.',
        warningNoActiveNoIndividual: 'No active competencies to deactivate.',
        warningSuffix:
            'Deactivated competencies will no longer be available for new selections (evaluations, profiles, templates).',
        cancel: 'Cancel',
        confirm: 'Deactivate',
        successToast: "Group '{{groupName}}' deactivated",
        activationSuccessToast: "Group '{{groupName}}' activated",
        activationSuccessToastWithRemaining:
            "Group '{{groupName}}' activated. {{remainingCount}} competency(ies) remain individually deactivated.",
        badge: 'Deactivated',
    },
    addOptions: {
        competency: 'Competency',
        competencyGroup: 'Competency group',
    },
    addCompetencyGroup: {
        title: 'Create a competency group',
        subtitle: 'Add a new group to organize your competencies',
        groupName: {
            label: 'Group name',
            placeholder: 'Ex: Communication, Leadership...',
        },
        groupDescription: {
            label: 'Description',
            placeholder: 'Description of the group...',
        },
        successMessage: 'Group created successfully',
        validation: {
            nameRequired: 'Group name is required',
        },
    },
    addCompetency: {
        title: 'Add a competency',
        subtitle: 'Enter the competency title and select a group.',
        competencyTitle: {
            label: 'Competency title',
            placeholder: 'Ex: Active listening, Critical thinking...',
        },
        competencyDescription: {
            label: 'Description',
            placeholder: 'Description of the competency...',
        },
        competencyGroupLabel: 'Group',
        competencyGroupPlaceholder: 'Select a group',
        successMessage: 'Competency created successfully',
        editSuccessMessage: 'Competency updated successfully',
        deleteSuccessMessage: "Competency '{{name}}' deleted",
        deleteSuccessWithGroupMessage:
            "Competency '{{name}}' deleted. The group '{{groupName}}' (empty) was also deleted.",
        deactivateSuccessMessage: 'Competency deactivated successfully',
        activateSuccessMessage: 'Competency activated successfully',
        editCompetency: 'Edit competency',
        deactivateCompetency: 'Deactivate competency',
        activateCompetency: 'Activate competency',
        deleteCompetency: 'Delete competency',
        deactivationConfirm: {
            title: 'Deactivate competency',
            message: 'Are you sure you want to deactivate this competency?',
            confirm: 'Deactivate',
            cancel: 'Cancel',
        },
        activationConfirm: {
            title: 'Activate competency',
            message: 'Are you sure you want to activate this competency?',
            confirm: 'Activate',
            cancel: 'Cancel',
        },
        lastActiveCompetencyConfirm: {
            title: 'Deactivate Last Active Competency',
            message:
                "Deactivating this competency will automatically deactivate the group '{{groupName}}'. Do you wish to proceed?",
            confirm: 'Deactivate',
            cancel: 'Cancel',
        },
        groupInactiveTooltip: 'The group is deactivated. Activate the group first.',
        deleteConfirm: {
            title: 'Delete competency',
            message: "Are you sure you want to delete the competency '{{name}}'?",
            warningTitle: 'Warning',
            warningMessage:
                'This action is irreversible. The competency will be permanently removed from the entire application, including historical results.',
            referencedInProfiles: 'Currently referenced in {{count}} profile(s)',
            evaluatedEmployees: '{{count}} employee(s) have been evaluated on this competency',
            associatedQuestions: '{{count}} associated question(s)',
            groupWillBeDeleted:
                "The group '{{groupName}}' will have no remaining competencies and will also be deleted.",
            blockedMessage:
                'This competency is referenced in {{count}} in-progress evaluation(s). Please complete or cancel these evaluations before deleting.',
            confirm: 'Delete',
            cancel: 'Cancel',
        },
        validation: {
            nameRequired: 'Competency name is required',
            groupIdRequired: 'Group is required',
        },
    },
    assignGroup: {
        chooseAssignmentModal: {
            title: 'Assign group « {{groupTitle}} »',
            subtitle: 'Assign the {{count}} competencies from this group :',
            chooseAssignmentMethod: 'Choose the Assignment Method',
            individualAssignment: {
                title: 'Individual assignment',
                description: 'Select specific employees manually',
            },
            ruleBasedAssignment: {
                title: 'Rule-based assignment',
                description: 'Assign based on employee attributes',
            },
            profileBasedAssignment: {
                title: 'Profile-based assignment',
                description: 'Select profile with search and multiselect',
            },
        },
        assignModal: {
            title: 'Assign group to employees',
            subtitle: 'Every competency in this group will be assigned to the selected employees.',
            chooseMethod: 'Choose the assignment method',
            methods: {
                individual: {
                    title: 'Individual assignment',
                    description: 'Select specific employees manually.',
                },
                rules: {
                    title: 'Rule-based assignment',
                    description: 'Assign employees by selected attributes.',
                },
                profiles: {
                    title: 'Profile-based assignment',
                    description: 'Reuse employees from existing profiles.',
                },
            },
            individual: {
                title: 'Find employees',
                searchPlaceholder: 'Search by name or email',
                alreadyAssigned: 'Already assigned',
            },
            rules: {
                title: 'Build assignment rules',
                subtitle: 'Filter employees by one or more attributes.',
                matchedCount: '{{count}} employees match these rules',
                attributeLabel: 'Attribute',
                attributePlaceholder: 'Select attribute',
                valuesLabel: 'Values',
                valuesPlaceholder: 'Type to filter...',
                noValues: 'No values available for this attribute.',
                selectAttributeHint: 'Select an attribute to choose matching values.',
                addAttribute: 'Add attribute',
            },
            profiles: {
                title: 'Select source profiles',
                searchPlaceholder: 'Search profiles',
                itemAssignedCount: '{{count}} employees',
                resultCount: '{{count}} profiles',
                noResults: 'No profiles match your search.',
            },
            review: {
                title: 'Review assignment',
                itemLabel: 'Group to assign',
                competencyCount: 'Includes {{count}} competencies',
                assignmentRules: 'Assignment rules',
                targetCountLabel: 'Employees targeted: {{count}}',
                rulesSummary: 'Rule: {{attribute}} / {{values}}',
                noMatch:
                    'No employees match the selected rules. Adjust your rules to assign the group.',
            },
            actions: {
                review: 'Review',
                assign: 'Assign',
            },
            messages: {
                success: 'Group assigned successfully.',
                noNewAssignments: 'All selected employees already had this group.',
                error: 'Unable to assign this group.',
            },
        },
    },
    modifyCompetencyGroup: {
        title: 'Modify competency group',
        subtitle: 'Modify the name and description of the competency group.',
    },
    modifyCompetency: {
        title: 'Edit competency',
        subtitle: 'Modify the title, description or group of the competency.',
    },
    competencies: {
        assignModal: {
            title: 'Assign competency to employees',
            subtitle: 'Choose a method and confirm assignment targets.',
            chooseMethod: 'Choose the assignment method',
            methods: {
                individual: {
                    title: 'Individual assignment',
                    description: 'Select specific employees manually.',
                },
                rules: {
                    title: 'Rule-based assignment',
                    description: 'Assign employees by selected attributes.',
                },
                profiles: {
                    title: 'Profile-based assignment',
                    description: 'Reuse employees from existing profiles.',
                },
            },
            individual: {
                title: 'Find employees',
                searchPlaceholder: 'Search by name or email',
                alreadyAssigned: 'Already assigned',
            },
            rules: {
                title: 'Build assignment rules',
                subtitle: 'Filter employees by one or more attributes.',
                matchedCount: '{{count}} employees match these rules',
                attributeLabel: 'Attribute',
                attributePlaceholder: 'Select attribute',
                valuesLabel: 'Values',
                valuesPlaceholder: 'Type to filter...',
                noValues: 'No values available for this attribute.',
                selectAttributeHint: 'Select an attribute to choose matching values.',
                addAttribute: 'Add attribute',
            },
            profiles: {
                title: 'Select source profiles',
                searchPlaceholder: 'Search profiles',
                itemAssignedCount: '{{count}} employees',
            },
            review: {
                title: 'Review assignment',
                itemLabel: 'Competency to assign',
                assignmentRules: 'Assignment rules',
                targetCountLabel: 'Employees targeted: {{count}}',
                rulesSummary: 'Rule: {{attribute}} / {{values}}',
            },
            actions: {
                review: 'Review',
                assign: 'Assign',
            },
            messages: {
                success: 'Competency assigned successfully.',
                error: 'Unable to assign this competency.',
            },
        },
    },
    profiles: {
        title: 'Competency profiles',
        description:
            'Manage profile assignments and target employees using individual, rules, or profile-based targeting.',
        actions: {
            assign: 'Assign',
        },
        card: {
            assignedCount: '{{count}} employees assigned',
            showDetails: 'Show assigned employees',
            hideDetails: 'Hide assigned employees',
            assignedEmployees: 'Assigned employees',
            emptyAssignedEmployees: 'No employees assigned to this profile yet.',
            employeeSearchPlaceholder: 'Search by name, role or department',
            noSearchResults: 'No employees match your search.',
            removeAssignedEmployee: {
                title: 'Remove assignment',
                message:
                    'Are you sure you want to remove this profile assignment for {{employeeName}}?',
                confirm: 'Remove',
                cancel: 'Cancel',
            },
        },
        assignModal: {
            title: 'Assign profile to employees',
            subtitle: 'Choose a method and confirm assignment targets.',
            chooseMethod: 'Choose the assignment method',
            methods: {
                individual: {
                    title: 'Individual assignment',
                    description: 'Select specific employees manually.',
                },
                rules: {
                    title: 'Rule-based assignment',
                    description: 'Assign employees by selected attributes.',
                },
                profiles: {
                    title: 'Profile-based assignment',
                    description: 'Reuse employees from existing profiles.',
                },
            },
            individual: {
                title: 'Find employees',
                searchPlaceholder: 'Search by name or email',
                alreadyAssigned: 'Already assigned',
            },
            rules: {
                title: 'Build assignment rules',
                subtitle: 'Filter employees by one or more attributes.',
                matchedCount: '{{count}} employees match these rules',
                attributeLabel: 'Attribute',
                attributePlaceholder: 'Select attribute',
                valuesLabel: 'Values',
                valuesPlaceholder: 'Type to filter...',
                noValues: 'No values available for this attribute.',
                selectAttributeHint: 'Select an attribute to choose matching values.',
                addAttribute: 'Add attribute',
            },
            profiles: {
                title: 'Select source profiles',
                searchPlaceholder: 'Search profiles',
                itemAssignedCount: '{{count}} employees',
                resultCount_one: '{{count}} profile',
                resultCount_other: '{{count}} profiles',
                noResults: 'No profiles match your search.',
            },
            review: {
                title: 'Review assignment',
                profileLabel: 'Profile to assign',
                itemLabel: 'Profile to assign',
                competencyCount_one: 'Includes {{count}} competency',
                competencyCount_other: 'Includes {{count}} competencies',
                noMatch:
                    'No employees match the selected rules. Adjust your rules to assign the profile.',
                assignmentRules: 'Assignment rules',
                targetCountLabel: 'Employees targeted: {{count}}',
                rulesSummary: 'Rule: {{attribute}} / {{values}}',
            },
            actions: {
                review: 'Review',
                assign: 'Assign',
            },
            messages: {
                success: 'Profile assigned successfully.',
                error: 'Unable to assign this profile.',
            },
        },
    },
    assignments: {
        title: 'Assign competency profiles',
        assignedTo: 'Assigned to {{count}} profiles',
        description:
            'Assign one competency profile per employee and manage active profile assignments.',
        assignForm: {
            profileLabel: 'Profile',
            profilePlaceholder: 'Select a profile',
            employeeLabel: 'Employee',
            employeePlaceholder: 'Select an employee',
            assignButton: 'Assign profile',
        },
        bulk: {
            title: 'Bulk assignment',
            description:
                'Select one profile and assign it to multiple employees with preview and overwrite control.',
            profileLabel: 'Profile to assign',
            profilePlaceholder: 'Select a profile',
            overwriteLabel: 'Overwrite existing profile assignments',
            selectedCount: '{{count}} employees selected',
            clearSelection: 'Clear selection',
            employeeSearchLabel: 'Find employees',
            employeeSearchPlaceholder: 'Search by employee name or email',
            emptySearchResult: 'No employees match your search.',
            previewTitle: 'Selection preview',
            previewEmpty: 'No employees selected yet.',
            assignButton: 'Assign selected employees',
            summary: {
                title: 'Execution summary',
                assigned: 'Assigned: {{count}}',
                unchanged: 'Unchanged: {{count}}',
                failed: 'Failed: {{count}}',
            },
        },
        filters: {
            profileLabel: 'Profile filter',
            profilePlaceholder: 'All profiles',
            searchLabel: 'Search employee',
            searchPlaceholder: 'Search by employee name or email',
        },
        list: {
            title: 'Active assignments',
            empty: 'No assignments found for the current filters.',
        },
        actions: {
            remove: 'Remove assignment',
        },
        messages: {
            assignSuccess: 'Competency profile assigned successfully.',
            assignError: 'Unable to assign competency profile.',
            bulkSuccess: 'Bulk assignment completed successfully.',
            bulkPartialSuccess: 'Bulk assignment completed with some conflicts.',
            bulkError: 'Unable to complete bulk assignment.',
            removeSuccess: 'Assignment removed successfully.',
            removeError: 'Unable to remove assignment.',
        },
    },
    competencyQuestions: {
        assessmentQuestions: 'Assessment questions for this competency:',
        emptyState: {
            description:
                'You haven\'t created any custom questions for this competency. The standard question will be used to evaluate it: "Do you believe that [first name] demonstrates the competency {{competencyName}}?"',
        },
        messages: {
            activated: 'Question activated',
            deactivated: 'Question deactivated',
            moved: "Question moved to '{{name}}'",
        },
    },
};
